import { render } from "./currency_selection.vue?vue&type=template&id=1201f8db"
import script from "./currency_selection.vue?vue&type=script&lang=js"
export * from "./currency_selection.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__